export default __webpack_public_path__ + "static/media/icon_ruby.4404fc91.png";